import { render, staticRenderFns } from "./selectTree.vue?vue&type=template&id=fc5430b4&scoped=true"
import script from "./selectTree.vue?vue&type=script&lang=js"
export * from "./selectTree.vue?vue&type=script&lang=js"
import style0 from "./selectTree.vue?vue&type=style&index=0&id=fc5430b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5430b4",
  null
  
)

export default component.exports